import { useNavigate } from "react-router-dom";
import RolesListTopbar from "../../features/manageSubAdmin/rolesTopbar";
import RolesList from "../../features/manageSubAdmin/rolesList";

const ManageSubadminRoles = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Manage Roles</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</button>
          {' '} - Manage Roles
        </p>
      </div>
      
      <div className="cards">
        <RolesListTopbar />
        <RolesList />
      </div>
    </>
  );
};

export default ManageSubadminRoles;
